import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useState } from "react";
import { LoadPopupPanel } from "../../../../components";
import { useGetCustomerNotifications } from "../api/get-customer-notifications";
import { RetailOrderContext } from "../context/RetailOrderContext";
import CustomerNotificationGrid from "./CustomerNotificationGrid";
import { ROType } from "../../../../types/enums";


export default function CustomerNotificationsButton() {

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const { order } = useContext(RetailOrderContext);

	const customerNotifications = useGetCustomerNotifications(order.details.retailOrderID, isPopupVisible);

	if (order.details.roTypeID === ROType.Vanity || order.details.roTypeID === ROType.VanityAddOn) {
		return (<></>);
	}

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-customer-notifications' }}
				text="Notifications"
				icon="Inscyth-Notifications"
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Customer Notifications"
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: () => setPopupVisibility(false)
					}}
					widget="dxButton"
					location="after"
				/>

				{
					isPopupVisible &&
					<CustomerNotificationGrid records={customerNotifications.data} />
				}

				<LoadPopupPanel visible={customerNotifications.isLoading}></LoadPopupPanel>
			</Popup>
		</>
	)
}
